<template>
    <div class="recherche">
        <label>
            <input type="text" class="recherche-input" placeholder="Recherche..." autocomplete="off" v-model="texteRecherche">
            <button type="button" class="recherche-button" id="recherche-button" @click="recherche"><v-icon size="24px">{{ mdiMagnify }}</v-icon></button>
        </label>
        <v-checkbox
            dark
            class="recherche-option"
            label="Ignorer la casse"
            v-model="ignoreCasse"
            v-on:change="prepareTextes"
            hide-details
        />
        <v-checkbox
            dark
            class="recherche-option"
            label="Ignorer l'accentuation"
            v-model="ignoreAccents"
            v-on:change="prepareTextes"
            hide-details
        />

        <div class="recherche-resultat" v-if="correspondances.length > 0">
            <button class="result-button-left" @click="precedent" :disabled="boutonPrecedentDesactive"><v-icon size="24px">{{ mdiChevronLeft }}</v-icon></button>
            <div>
                <span id="result-text">{{ info }}</span>
            </div>
            <button class="result-button-right" @click="suivant" :disabled="boutonSuivantDesactive"><v-icon size="24px">{{ mdiChevronRight }}</v-icon></button>
        </div>

        <button type="button" class="recherche-close" @click="fermeRecherche">Fermer</button>
    </div>
</template>

<script>
import { mdiMagnify, mdiChevronLeft, mdiChevronRight } from "@mdi/js";

export default {
    name: "LiseuseRecherche",
    data: () => ({
        //case à cocher
        ignoreCasse: true,
        ignoreAccents: true,
        texteRecherche: '',

        boutonPrecedentDesactive: false,
        boutonSuivantDesactive: false,
        info: '',

        correspondances: [],
        positionCorrespondance: 0,

        //contenu reçu en props après traitement effectué selon case à cocher
        textesTraites: {},

        tableAccents: [
            {'base':'A', 'lettres':/[\u0041\u24B6\uFF21\u00C0\u00C1\u00C2\u1EA6\u1EA4\u1EAA\u1EA8\u00C3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\u00C4\u01DE\u1EA2\u00C5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F]/g},
            {'base':'AA','lettres':/[\uA732]/g},
            {'base':'AE','lettres':/[\u00C6\u01FC\u01E2]/g},
            {'base':'AO','lettres':/[\uA734]/g},
            {'base':'AU','lettres':/[\uA736]/g},
            {'base':'AV','lettres':/[\uA738\uA73A]/g},
            {'base':'AY','lettres':/[\uA73C]/g},
            {'base':'B', 'lettres':/[\u0042\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181]/g},
            {'base':'C', 'lettres':/[\u0043\u24B8\uFF23\u0106\u0108\u010A\u010C\u00C7\u1E08\u0187\u023B\uA73E]/g},
            {'base':'D', 'lettres':/[\u0044\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779]/g},
            {'base':'DZ','lettres':/[\u01F1\u01C4]/g},
            {'base':'Dz','lettres':/[\u01F2\u01C5]/g},
            {'base':'E', 'lettres':/[\u0045\u24BA\uFF25\u00C8\u00C9\u00CA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\u00CB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E]/g},
            {'base':'F', 'lettres':/[\u0046\u24BB\uFF26\u1E1E\u0191\uA77B]/g},
            {'base':'G', 'lettres':/[\u0047\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E]/g},
            {'base':'H', 'lettres':/[\u0048\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D]/g},
            {'base':'I', 'lettres':/[\u0049\u24BE\uFF29\u00CC\u00CD\u00CE\u0128\u012A\u012C\u0130\u00CF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197]/g},
            {'base':'J', 'lettres':/[\u004A\u24BF\uFF2A\u0134\u0248]/g},
            {'base':'K', 'lettres':/[\u004B\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2]/g},
            {'base':'L', 'lettres':/[\u004C\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780]/g},
            {'base':'LJ','lettres':/[\u01C7]/g},
            {'base':'Lj','lettres':/[\u01C8]/g},
            {'base':'M', 'lettres':/[\u004D\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C]/g},
            {'base':'N', 'lettres':/[\u004E\u24C3\uFF2E\u01F8\u0143\u00D1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4]/g},
            {'base':'NJ','lettres':/[\u01CA]/g},
            {'base':'Nj','lettres':/[\u01CB]/g},
            {'base':'O', 'lettres':/[\u004F\u24C4\uFF2F\u00D2\u00D3\u00D4\u1ED2\u1ED0\u1ED6\u1ED4\u00D5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\u00D6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\u00D8\u01FE\u0186\u019F\uA74A\uA74C]/g},
            {'base':'OI','lettres':/[\u01A2]/g},
            {'base':'OO','lettres':/[\uA74E]/g},
            {'base':'OU','lettres':/[\u0222]/g},
            {'base':'P', 'lettres':/[\u0050\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754]/g},
            {'base':'Q', 'lettres':/[\u0051\u24C6\uFF31\uA756\uA758\u024A]/g},
            {'base':'R', 'lettres':/[\u0052\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782]/g},
            {'base':'S', 'lettres':/[\u0053\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784]/g},
            {'base':'T', 'lettres':/[\u0054\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786]/g},
            {'base':'TZ','lettres':/[\uA728]/g},
            {'base':'U', 'lettres':/[\u0055\u24CA\uFF35\u00D9\u00DA\u00DB\u0168\u1E78\u016A\u1E7A\u016C\u00DC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244]/g},
            {'base':'V', 'lettres':/[\u0056\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245]/g},
            {'base':'VY','lettres':/[\uA760]/g},
            {'base':'W', 'lettres':/[\u0057\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72]/g},
            {'base':'X', 'lettres':/[\u0058\u24CD\uFF38\u1E8A\u1E8C]/g},
            {'base':'Y', 'lettres':/[\u0059\u24CE\uFF39\u1EF2\u00DD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE]/g},
            {'base':'Z', 'lettres':/[\u005A\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762]/g},
            {'base':'a', 'lettres':/[\u0061\u24D0\uFF41\u1E9A\u00E0\u00E1\u00E2\u1EA7\u1EA5\u1EAB\u1EA9\u00E3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\u00E4\u01DF\u1EA3\u00E5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250]/g},
            {'base':'aa','lettres':/[\uA733]/g},
            {'base':'ae','lettres':/[\u00E6\u01FD\u01E3]/g},
            {'base':'ao','lettres':/[\uA735]/g},
            {'base':'au','lettres':/[\uA737]/g},
            {'base':'av','lettres':/[\uA739\uA73B]/g},
            {'base':'ay','lettres':/[\uA73D]/g},
            {'base':'b', 'lettres':/[\u0062\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253]/g},
            {'base':'c', 'lettres':/[\u0063\u24D2\uFF43\u0107\u0109\u010B\u010D\u00E7\u1E09\u0188\u023C\uA73F\u2184]/g},
            {'base':'d', 'lettres':/[\u0064\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A]/g},
            {'base':'dz','lettres':/[\u01F3\u01C6]/g},
            {'base':'e', 'lettres':/[\u0065\u24D4\uFF45\u00E8\u00E9\u00EA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\u00EB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD]/g},
            {'base':'f', 'lettres':/[\u0066\u24D5\uFF46\u1E1F\u0192\uA77C]/g},
            {'base':'g', 'lettres':/[\u0067\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F]/g},
            {'base':'h', 'lettres':/[\u0068\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265]/g},
            {'base':'hv','lettres':/[\u0195]/g},
            {'base':'i', 'lettres':/[\u0069\u24D8\uFF49\u00EC\u00ED\u00EE\u0129\u012B\u012D\u00EF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131]/g},
            {'base':'j', 'lettres':/[\u006A\u24D9\uFF4A\u0135\u01F0\u0249]/g},
            {'base':'k', 'lettres':/[\u006B\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3]/g},
            {'base':'l', 'lettres':/[\u006C\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747]/g},
            {'base':'lj','lettres':/[\u01C9]/g},
            {'base':'m', 'lettres':/[\u006D\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F]/g},
            {'base':'n', 'lettres':/[\u006E\u24DD\uFF4E\u01F9\u0144\u00F1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5]/g},
            {'base':'nj','lettres':/[\u01CC]/g},
            {'base':'o', 'lettres':/[\u006F\u24DE\uFF4F\u00F2\u00F3\u00F4\u1ED3\u1ED1\u1ED7\u1ED5\u00F5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\u00F6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\u00F8\u01FF\u0254\uA74B\uA74D\u0275]/g},
            {'base':'oi','lettres':/[\u01A3]/g},
            {'base':'ou','lettres':/[\u0223]/g},
            {'base':'oo','lettres':/[\uA74F]/g},
            {'base':'p','lettres':/[\u0070\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755]/g},
            {'base':'q','lettres':/[\u0071\u24E0\uFF51\u024B\uA757\uA759]/g},
            {'base':'r','lettres':/[\u0072\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783]/g},
            {'base':'s','lettres':/[\u0073\u24E2\uFF53\u00DF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B]/g},
            {'base':'t','lettres':/[\u0074\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787]/g},
            {'base':'tz','lettres':/[\uA729]/g},
            {'base':'u','lettres':/[\u0075\u24E4\uFF55\u00F9\u00FA\u00FB\u0169\u1E79\u016B\u1E7B\u016D\u00FC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289]/g},
            {'base':'v','lettres':/[\u0076\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C]/g},
            {'base':'vy','lettres':/[\uA761]/g},
            {'base':'w','lettres':/[\u0077\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73]/g},
            {'base':'x','lettres':/[\u0078\u24E7\uFF58\u1E8B\u1E8D]/g},
            {'base':'y','lettres':/[\u0079\u24E8\uFF59\u1EF3\u00FD\u0177\u1EF9\u0233\u1E8F\u00FF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF]/g},
            {'base':'z','lettres':/[\u007A\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763]/g}
        ],
        mdiMagnify,
        mdiChevronLeft,
        mdiChevronRight
    }),
    props: {
        contenu: {
            type: Object,
            required: true,
        }
    },
    methods: {
        reinitialiseTraitement() {
            this.prepareTextes();
            this.correspondances = [];
            this.positionCorrespondance = 0;
        },
        prepareTextes() {
            let textesTraites = Object.assign({}, this.contenu);
            if (this.ignoreAccents) textesTraites = this.neutraliseAccents(textesTraites);
            if (this.ignoreCasse) textesTraites = this.neutraliseCasse(textesTraites);
            this.$set(this,'textesTraites', textesTraites);
        },
        recherche() { //effectue la recherche
            this.reinitialiseTraitement();
            let recherche = this.texteRecherche;
            this.afficheResultats(this.rechecheTexte(recherche));
        },

        afficheResultats(correspondances) {
            if (!correspondances.length) {
                this.desactiverResultats()
                return;
            }

            this.correspondances = correspondances;
            this.positionCorrespondance = 0;
            this.afficheCorrespondance();
        },
        afficheCorrespondance() {
            this.boutonPrecedentDesactive = this.positionCorrespondance < 1;
            this.boutonSuivantDesactive = this.positionCorrespondance >= this.correspondances.length - 1;
            this.info = "Occurrence " +  (this.positionCorrespondance + 1) + "/" + this.correspondances.length;
            //transmet à l'objet parent la page à afficher
            this.$emit('gotopage', this.correspondances[this.positionCorrespondance])
        },
        desactiverResultats() {
            this.boutonPrecedentDesactive = true;
            this.boutonSuivantDesactive = true;
            this.info = "Aucun résultat";
        },
        precedent () {
            if (this.boutonPrecedentDesactive) return;
            this.positionCorrespondance--;
            this.afficheCorrespondance();
        },
        suivant () {
            if (this.boutonSuivantDesactive) return;
            this.positionCorrespondance++;
            this.afficheCorrespondance();
        },
        definiResultat(contenu) {
            if (! (typeof contenu === 'object' && contenu instanceof Object) ) return;

            this.baseContent = contenu;
            this.computedContent = {};

            this.reinitialiseTraitement();
        },
        fermeRecherche() {
            this.$emit('close');
        },
        rechecheTexte(texteRecherche) {
            if (this.ignoreCasse) texteRecherche = this.neutraliseCasse(texteRecherche);
            if (this.ignoreAccents) texteRecherche = this.neutraliseAccents(texteRecherche);

            let clefs = [];

            for (let clef in this.textesTraites) {
                if (!Object.hasOwnProperty.call(this.textesTraites, clef)) continue;
                if (~this.textesTraites[clef].indexOf(texteRecherche)) clefs.push(parseInt(clef))
            }
            return clefs
        },
        neutraliseCasse (textes) {
            if (typeof textes === "string") {
                textes = textes.toLowerCase();
            } else {
                for (let key in textes) {
                    if (!Object.hasOwnProperty.call(textes, key)) continue;
                    textes[key] = textes[key].toLowerCase();
                }
            }
            return textes;
        },
        neutraliseAccents (textes) {
            if (typeof textes === "string") {
                for (let i = 0; i < this.tableAccents.length; i++) {
                    textes = textes.replace(this.tableAccents[i].lettres, this.tableAccents[i].base);
                }
            } else {
                for (let key in textes) {
                    if (!Object.hasOwnProperty.call(textes, key)) continue;
                    for (let i = 0; i < this.tableAccents.length; i++) {
                        textes[key] = textes[key].replace(this.tableAccents[i].lettres, this.tableAccents[i].base);
                    }
                }
            }
            return textes;
        }
    },
    mounted() {
        this.prepareTextes();
    }
}
</script>
<style scoped lang="scss">
$gris_plus_sombre:  #444444;
$gris_sombre:       #666666;
$gris_moyen:        #a5a5a5;
$gris_clair:        #bbbbbb;
$gris_tres_clair:   #b7b7b7;
$blanc_casse:       #f5f5f5;
$blanc:             #ffffff;
.recherche {
    position: absolute;
    top: 8%;
    right: 8%;
    padding: 0.5em;
    background-color: rgba(33,33,33, 0.7);
//    background-color: $gris_sombre;
    color: $blanc_casse;
    border: 1px solid $gris_plus_sombre;
    border-radius: 5px;
    z-index: 2000;
    box-shadow: 2px 2px 8px rgba(0, 0, 0, 0.4);
    > label {
        display: flex;
    }
    & .recherche-input {
        display: inline-block;
        box-sizing: border-box;
        border: 1px solid $gris_tres_clair;
        border-radius: 5px 0 0 5px;
        color: $gris_plus_sombre;
        text-overflow: clip;
        font-weight: bold;
        font-size: 16px;
        background: $blanc_casse;
        box-shadow: 2px 2px 2px 0 rgba(0,0,0,0.2) inset;
        padding: 0.5em;
        margin-bottom: 1em;
        height: 40px;
    }
    & .recherche-button {
        display: inline-block;
        box-sizing: border-box;
        border: 1px solid $gris_tres_clair;
        border-radius: 0 5px 5px 0;
        color: $gris_plus_sombre;
        padding-top: 3px;
        font-size: 16px;
        background-color: $blanc_casse;
        box-shadow: 2px 2px 2px 0 rgba(0,0,0,0.2) inset;
        margin-bottom: 0.5em;
        height: 40px;
        width: 40px;
        cursor: pointer;
        outline: none;
    }

    & .recherche-button:active, .recherche-button:hover{
        background-color: $gris_moyen;
        color: $blanc_casse;
    }

    & .recherche-option {
        display: block !important;
        font-size: 16px;
    }
    & .recherche-option:hover {
        color: $blanc;
    }
    & .recherche-resultat {
        display: flex;
        margin-top: 1em;
        justify-content: space-between;
        align-items: center;
        font-size: 16px;
        height: 2em;
        color: $gris_plus_sombre;
        box-sizing: border-box;
        > div {
            display: flex;
            flex: 1;
            height: 100%;
            background-color: $blanc_casse;
            box-sizing: border-box;
            padding: 5px;
            > span {
                margin: auto;
            }
        }
        .result-button-left {
            display: inline-block;
            box-sizing: border-box;
            height: 100%;
            border: 1px solid $gris_tres_clair;
            border-radius: 5px 0 0 5px;
            background-color: $blanc_casse;
            cursor: pointer;
            outline: none;
            width: 30px;
            >i {
                line-height: 30px;
            }
        }
        & .result-button-right {
            display: inline-block;
            box-sizing: border-box;
            height: 100%;
            border: 1px solid $gris_tres_clair;
            border-radius: 0 5px 5px 0;
            background-color: $blanc_casse;
            cursor: pointer;
            outline: none;
            width: 30px;
            .mdi {
                line-height: 30px;
            }
        }
        & .result-button-right:not([disabled]):active {
            background-color: $gris_moyen;
        }
        & .result-button-right:disabled {
            background-color: $gris_clair;
            cursor: not-allowed;
        }
        & .result-button-left:not([disabled]):active {
            background-color: $gris_moyen;
        }
        & .result-button-left:disabled {
            background-color: $gris_clair;
            cursor: not-allowed;
        }
    }
    & .recherche-close {
        display: block;
        box-sizing: border-box;
        padding: 0.3em 1em;
        height: 2em;
        font-size: 15px;
        border: 1px solid $gris_tres_clair;
        border-radius: 5px;
        background-color: $blanc_casse;
        cursor: pointer;
        outline: none;
        margin-top: 1em;
        color: $gris_plus_sombre;
        float: right;
        line-height: 18px;
    }
    & .recherche-close:hover {
        background-color: $gris_moyen;
        border: 1px solid $gris_sombre;
        color: $blanc_casse;
    }
}

</style>